export default __webpack_public_path__ + "static/media/013-distribution-3.383ba180.png";